<template>
  <div class="expansion-panel overflow-hidden" :class="getExpansionStyle" :style="{ background: getBackgroundColor }">
    <div class="title d-flex justify-space-between" :class="isPanelActive ? 'active' : ''" @click="togglePanel">
      <div class="title-text">
        <slot name="title" />
      </div>
      <div class="title-icon"></div>
    </div>
    <transition name="slide-fade">
      <div v-if="isPanelActive" ref="content" class="content" :style="{ background: getBackgroundColor }">
        <div class="pb-5">
          <slot name="content" />
        </div>
      </div>
    </transition>
  </div>
</template>

<script lang="ts">
  import { defineComponent } from 'vue'
  import type { PropType } from 'vue'

  export default defineComponent({
    name: 'BaseExpansionPanel',
    props: {
      expansionBG: {
        type: Array as PropType<string[]>,
        default: () => ['#FFFFFF', '#FFFFFF'],
      },
      expansionStyle: {
        type: String as PropType<'default' | 'classic'>,
        default: 'default',
        validate(val: string) {
          return ['default', 'classic'].includes(val)
        },
      },
      isOpened: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        isPanelActive: this.isOpened,
      }
    },
    computed: {
      getBackgroundColor(): string {
        return this.isPanelActive ? this.expansionBG[1] : this.expansionBG[0]
      },
      getExpansionStyle() {
        switch (this.expansionStyle) {
          case 'classic':
            return 'expansion-panel-classic'
          default:
            return 'expansion-panel-default'
        }
      },
    },
    methods: {
      togglePanel() {
        this.isPanelActive = !this.isPanelActive
      },
    },
  })
</script>

<style scoped lang="scss">
  .expansion-panel {
    text-align: left;
    transition: 0.4s;

    &-default {
      .title {
        padding: 15px 20px;
      }
      .content {
        padding: 0 20px;
      }
    }

    &-classic {
      border-radius: 0;
      .title {
        padding: 5px;
      }
      .content {
        padding: 0 5px;
      }
    }

    .title {
      cursor: pointer;
      &.active {
        border-radius: 15px 15px 0 0;
        & .title-icon:after {
          transform: rotate(90deg);
        }
      }

      &-text {
        width: 100%;
        word-break: break-word;
        padding-right: 10px;
      }

      &-icon {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-right: 10px;
        &:after {
          content: '\276E';
          transform: rotate(-90deg);
          font-size: 20px;
          float: right;
          color: #777;
          margin-left: 5px;
          transition: 0.4s;
        }
      }
    }

    .content {
      border-radius: 0 0 15px 15px;
    }
    &.no-padding-y {
      .expansion-panel-title,
      .expansion-panel-content {
        padding-left: 0;
        padding-right: 0;
      }
    }
  }
</style>
